import React from "react";

export default function ColorPicker({ label, value, onChange }) {
  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <input type="color" className="color-input" value={value} onChange={(e) => onChange(e.target.value)} />
        <input
          type="text"
          className="form-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{ maxWidth: 120 }}
        />
      </div>
    </div>
  );
}
